import { render, staticRenderFns } from "./SiteRolesTable.vue?vue&type=template&id=19f64772&"
import script from "./SiteRolesTable.vue?vue&type=script&lang=ts&"
export * from "./SiteRolesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports